import { createRouter, createWebHistory } from 'vue-router'
import store from '../store';


const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/HomeView.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Home' }],
    },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/HomeView.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Login' }],
      },
    },
    {
      path: '/input-for-reset-password',
      name: 'input-for-reset-password',
      component: () => import('../views/reset-password/InputForResetPasswordForm.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Reset Password' }],
      },
    },
    {
      path: '/update-password',
      name: 'update-password',
      component: () => import('../views/reset-password/UpdatePasswordForm.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Update Password' }],
      },
    },
    {
      path: '/reset-password/:code',
      name: 'reset-password',
      component: () => import('../views/reset-password/ResetPasswordForm.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Reset Password' }],
      },
      props: true
    },
    {
      path: '/tanks-movements-list-a-18',
      name: 'tanks-movements-list-a-18',
      component: () => import('../views/fiscal-notification/documents/TanksMovementsListA18.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'TanksMovementsListA18' }],
      },
    }, {
      path: '/hter9',
      name: 'hter9',
      component: () => import('../views/fiscal-notification/documents/HTER9.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'HTER9' }],
      },
    }, 
    {
      path: '/additive-report',
      name: 'additive-report',
      component: () => import('../views/fiscal-notification/documents/Additive.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Additive' }],
      },
    },
    {
      path: '/vetting-safety',
      name: 'vetting-safety',
      component: () => import('../views/vetting/Safety.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'VettingSafety' }],
      },
    },
    {
      path: '/stock-summary',
      name: 'stock-summary',
      component: () => import('../views/fiscal-notification/documents/StockSummary.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockSummary' }],
      },
    },
    {
      path: '/equipment-operation-import-ecvt',
      name: 'equipment-operation-import-ecvt',
      component: () => import('../views/equipment-operation/ImportCVT.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Import CVT' }],
      },
    },
    {
      path: '/equipment-operation-cvt-deviation',
      name: 'equipment-operation-cvt-deviation',
      component: () => import('../views/equipment-operation/CVTDeviation.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'CVT Deviation' }],
      },
    },
    {
      path: '/equipment-operation-cvt-report',
      name: 'equipment-operation-cvt-report',
      component: () => import('../views/equipment-operation/CVTReport.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'CVT Report' }],
      },
    },
    {
      path: '/tank-tracking',
      name: 'tank-tracking',
      component: () => import('@/views/tank-management/TankTracking.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Tank Tracking' }],
      },
    },
    {
      path: '/product-stock',
      name: 'product-stock',
      component: () => import('../views/material-balance/ProductStock.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Product Stock' }],
      },
    },
    {
      path: '/processing-production',
      name: 'processing-production',
      component: () => import('../views/material-balance/ProcessingProductionManagement.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Processing Production Management' }],
      },
    },
    {
      path: '/monthly-material-balance',
      name: 'monthly-material-balance',
      component: () => import('../views/material-balance/MonthlyMaterialBalance.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Monthly Material Balance' }],
      },
    },
    {
      path: '/lots-management',
      name: 'lots-management',
      component: () => import('../views/material-balance/LotsManagement.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Lots Management' }],
      },
    },
    {
      path: '/compulsory-stocks',
      name: 'compulsory-stocks',
      component: () => import('../views/material-balance/CompulsoryStocks.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Compulsory Stocks' }],
      },
    },
    {
      path: '/daily-compulsory-stocks',
      name: 'daily-compulsory-stocks',
      component: () => import('../views/material-balance/DailyCompulsoryStocks.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Daily Compulsory Stocks' }],
      },
    },
    {
      path: '/tank-management',
      name: 'tank-management',
      component: () => import('../views/tank-management/TankManagement.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Tank Management' }],
      },
    },
    {
      path: '/tank-calculator',
      name: 'tank-calculator',
      component: () => import('../views/tank-management/Calculator.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Calculator' }],
    },
    },
    {
      path: '/tank/operations/:id',
      name: 'tank-operation-detail',
      component: () => import('../views/tank-management/TankOperationDetail.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Tank Operation Detail' }],
      },
      props: true
    },
    {
      path: '/tank/operations',
      name: 'tank-operations',
      component: () => import('../views/tank-management/TankOperations.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Tank Operations' }],
    },
    },
    {
      path: '/operative-plan',
      name: 'operative-plan',
      component: () => import('../views/operative-plan/OperativePlan.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Operative Plan' }],
    },
    },
    {
      path: '/daily-plan-report',
      name: 'daily-plan-report',
      component: () => import('../views/operative-plan/DailyPlanReport.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Daily Plan Report' }],
    },
    },
    {
      path: '/daily-plan-validation',
      name: 'daily-plan-validation',
      component: () => import('../views/operative-plan/DailyPlanValidation.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Daily Plan Validation' }],
    },
    },
    {
      path: '/daily-plan-management',
      name: 'daily-plan-management',
      component: () => import('../views/operative-plan/DailyPlanManagement.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Daily Plan Management' }],
    },
    },
    {
      path: '/product-aggregation',
      name: 'product-aggregation',
      component: () => import('../views/product-aggregation/ProductAggregation.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Product Aggregation' }],
      },
    
    }, 
    // {
    //   path: '/product-specification-details/:id',
    //   name: 'product-specification-details-grid',
    //   props: { name: 'ProductSpecificationDetail', category: 'product-specification-details' },
    //   component: () => import('../views/product-specification/ProductSpecificationDetailsGrid.vue'),
    //   meta: {
    //       breadcrumb: [{ parent: 'Home', label: 'Product Specification Details Grid' }],
    // },
    // },
    // {
    //   path: '/product-specification-details/:id/:detailId',
    //   name: 'product-specification-details-form',
    //   component: () => import('../views/product-specification/ProductSpecificationDetailsForm.vue'),
    //   meta: {
    //       breadcrumb: [{ parent: 'Home', label: 'Product Specification Details Form' }],
    //   },
    //   props: { name: 'ProductSpecificationDetail', category: 'product-specification-details' }
    // },
    // {
    //   path: '/product-specification-note/:id/:detailId',
    //   name: 'product-specification-note-form',
    //   component: () => import('../views/product-specification/ProductSpecificationNoteForm.vue'),
    //   meta: {
    //       breadcrumb: [{ parent: 'Home', label: 'Product Specification Note Form' }],
    //   },
    //   props: { name: 'ProductSpecificationNote', category: 'product-specification-notes' }
    // },
    {
      path: '/movement-instruction',
      name: 'movement-instruction',
      props: { category: 'movementInstruction', name: 'MovementInstruction' },
      component: () => import('../views/movement-instruction/MovementInstructionGridV2.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Movement Instruction' }],
    },
  },
  {
    path: '/stocchino-plan/OperativeLevels',
    name: 'stocchino-plan-operative-levels',
    props: { category: 'stocchino-plan', name: 'OperativeLevels' },
    component: () => import('../views/planning/OperativeLevels.vue'),
    meta: {
        breadcrumb: [{ parent: 'Home', label: 'Operative Levels' }],
  },
  },
  {
    path: '/stocchino-plan/plan',
    name: 'stocchino-plan-stocchino-plan',
    component: () => import('../views/planning/StocchinoPlan.vue'),
    meta: {
        breadcrumb: [{ parent: 'Home', label: 'Stocchino Plan' }],
  },
  },
  
  {
    path: '/master-data/TankExceptions',
    name: 'stocchino-plan-tank-exceptions',
    props: { category: 'stocchino-plan', name: 'TankExceptions' },
    component: () => import('../views/planning/TankExceptions.vue'),
    meta: {
        breadcrumb: [{ parent: 'Home', label: 'Operative Levels' }],
  },
},
  {
    path: '/master-data/FamilyPoolConfiguration',
    name: 'stocchino-plan-tank-exceptions',
    props: { category: 'master-data', name: 'FamilyPoolConfiguration' },
    component: () => import('../views/planning/trueUp/FamilyPoolConfiguration.vue'),
    meta: {
        breadcrumb: [{ parent: 'Home', label: 'Operative Levels' }],
  },
  },
    {
      path: '/master-data/StocchinoPlanProductAggregation',
      name: 'stocchino-plan-product-aggregation',
      props: { category: 'stocchino-plan', name: 'StocchinoPlanProductAggregation' },
      component: () => import('../views/generic/GenericTreeTableView.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Operative Levels' }],
    },
    },
    
    {
      path: '/master-data/StocchinoPlanFamilyAggregation',
      name: 'stocchino-plan-family-aggregation',
      props: { category: 'stocchino-plan', name: 'StocchinoPlanFamilyAggregation' },
      component: () => import('../views/planning/FamilyAggregationView.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Operative Levels' }],
    },
    },
    {
      path: '/master-data/StocchinoPlanFamilyAssociation',
      name: 'stocchino-plan-family-association',
      props: { category: 'stocchino-plan', name: 'StocchinoPlanFamilyAssociation' },
      component: () => import('../views/planning/FamilyAggregationAssociationView.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Operative Levels' }],
    },
    },
    {
      path: '/movement-instruction/:id',
      name: 'movement-instruction-details',
      component: () => import('../views/movement-instruction/MovementInstructionV2.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Movement Instruction Details' }],
      },
      props: true
      // props: { id: 0, startInEdit: false }
    },
    {
      path: '/movement-instruction/checklist',
      name: 'checklist',
      component: () => import('../views/movement-instruction/Checklist.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Movement Instruction Checklist' }],
      },
      props: true
    },
    {
      path: '/stock-management/daily-tank',
      name: 'stock-management-daily-tank',
      props: { category: 'stock-management', name: 'StockManagementDailyTank' },
      component: () => import('../views/stock-management/Tank.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementDailyTank' }],
    },
    },
    {
      path: '/stock-management/monthly-tank',
      name: 'stock-management-monthly-tank',
      props: { category: 'stock-management', name: 'StockManagementDailyTank' },
      component: () => import('../views/stock-management/TankMonthly.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementMonthlyTank' }],
    },
    },
    {
      path: '/stock-management/daily-pipe',
      name: 'stock-management-daily-pipe',
      props: { category: 'stock-management', name: 'StockManagementDailyPipe' },
      component: () => import('../views/stock-management/Pipe.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementDailyPipe' }],
    },
    },
    {
      path: '/stock-management/monthly-pipe',
      name: 'stock-management-monthly-pipe',
      props: { category: 'stock-management', name: 'StockManagementDailyPipe' },
      component: () => import('../views/stock-management/PipeMonthly.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementMonthlyPipe' }],
    },
    },
    {
      path: '/stock-management/daily-dead-stock',
      name: 'stock-management-daily-dead-stock',
      props: { category: 'stock-management', name: 'StockManagementDailyDeadStock' },
      component: () => import('../views/stock-management/DeadStock.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementDailyDeadStock' }],
    },
    },
    {
      path: '/stock-management/daily-locked',
      name: 'stock-management-daily-locked',
      props: { category: 'stock-management', name: 'daily-locked' },
      component: () => import('../views/stock-management/LockedDaily.vue'),
        meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementLockedDaily' }],
      },
    },
    {
      path: '/stock-management/manual-edit-log',
      name: 'stock-management-manual-edit-log',
      props: { category: 'stock-management', name: 'StockManagementManualEditLog' },
      component: () => import('../views/stock-management/ManualEditLog.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementManualEditLog' }],
    },
    },
    {
      path: '/stock-management/manual-edit-log',
      name: 'stock-management-manual-edit-log',
      props: { category: 'stock-management', name: 'StockManagementManualEditLog' },
      component: () => import('../views/stock-management/ManualEditLog.vue'),
        meta: {
            breadcrumb: [{ parent: 'Home', label: 'StockManagementManualEditLog' }],
      },
    },
    {
      path: '/stock-management/mts',
      name: 'stock-management-mts',
      props: { category: 'stock-management', name: 'StockManagementMts' },
      component: () => import('../views/stock-management/Mts.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementMts' }],
      },
    },
    {
      path: '/stock-management/inventory',
      name: 'stock-management-inventory',
      props: { category: 'stock-management', name: 'StockManagementInventory' },
      component: () => import('../views/stock-management/Inventory.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementInventory' }],
      }
    },
    {
      path: '/stock-management/inventory-data-staging',
      name: 'stock-management-inventory-data-staging',
      props: { category: 'stock-management', name: 'StockManagementInventoryDataStaging' },
      component: () => import('../views/stock-management/InventoryDataStaging.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'StockManagementInventoryDataStaging' }],
      }
    },
    {
      path: '/:category/:name',
      name: 'generic-panel',
      component: () => import('../views/generic/GenericCustomGridV2.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: `Master Data` }],
      },
      props: true
    },
    {
      path: '/:category/:name/:id',
      name: 'generic-details',
      component: () => import('../views/generic/GenericCustomFormV2.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Master Data Details' }],
      },
      props: true
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: () => import('../views/notification/Notification.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Notification' }],
      },
      props: true
    },
    {
      path: '/threads/',
      name: 'threads',
      component: () => import('../views/thread/Thread.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Thread' }],
      },
      props: true
    },
    {
      path: '/threads/:id',
      name: 'thread',
      component: () => import('../views/thread/ThreadForm.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Thread Form' }],
      },
      props: true
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/search/Search.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Search' }],
      },
      props: true
    },
    {
      path: '/jetty/timesheet',
      name: 'timesheet',
      component: () => import('../views/jetty/Timesheet.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Timesheet' }],
      },
      props: true
    },
    {
      path: '/jetty/eta',
      name: 'jetty-eta',
      component: () => import('../views/jetty/Eta.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Eta' }],
      },
      props: true
    },
    {
      path: '/jetty/ullage',
      name: 'jetty-ullage',
      component: () => import('../views/jetty/Ullage.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Ullage' }],
      },
      props: true
    },
    {
      path: '/jetty/ullage/:id',
      name: 'jetty-ullage-details',
      component: () => import('../views/jetty/UllageDetails.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Ullage' }],
      },
      props: true
    },
    {
      path: '/vessel-protocol',
      name: 'vessel-protocol',
      component: () => import('../views/vessel-protocol/VesselProtocol.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Vessel Protocol' }],
      },
      props: true
    },
    {
      path: '/vessel-protocol-alerts',
      name: 'vessel-protocol-alerts',
      component: () => import('../views/generic/GenericCustomGridV2.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Vessel Protocol Alerts' }],
      },
      props: { category: 'vessel-protocol-alerts', name: 'VesselProtocolAlerts' }
    },
    {
      path: '/vessel-protocol-alerts-details',
      name: 'vessel-protocol-alerts-details',
      component: () => import('../views/vessel-protocol/VesselProtocolAlerts.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Vessel Protocol' }],
      },
      props: true
    },
    {
      path: '/vessel-protocol-documents-search',
      name: 'vessel-protocol-documents-search',
      component: () => import('../views/vessel-protocol/VesselProtocolDocumentSearch.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Vessel Protocol' }],
      },
      props: true
    },
    {
      path: '/vessel-protocol-tributes-search',
      name: 'vessel-protocol-tributes-search',
      component: () => import('../views/vessel-protocol/VesselProtocolTributeSearch.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Vessel Protocol' }],
      },
      props: true
    },
    {
      path: '/vessel-protocol-search',
      name: 'vessel-protocol-search',
      component: () => import('../views/vessel-protocol/VesselProtocolSearch.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Vessel Protocol Search' }],
      },
      props: true
    },
    {
      path: '/vessel-protocol-general-reports',
      name: 'vessel-protocol-general-reports',
      component: () => import('../views/vessel-protocol/VesselProtocolGeneralReport.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Vessel Protocol' }],
      },
      props: true
    },
    {
      path: '/vessel-protocol-protocol-reports',
      name: 'vessel-protocol-protocol-reports',
      component: () => import('../views/vessel-protocol/VesselProtocolProtocolReport.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Vessel Protocol' }],
      },
      props: true
    },
    {
      path: '/menu-configuration',
      name: 'menu-configuration',
      component: () => import('../views/permission/Menu.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Menu' }],
      },
      props: true
    },
    {
      path: '/clearance-document/issue-of-documents',
      name: 'issue-of-documents',
      component: () => import('../views/clearance-document/IssueOfDocuments.vue'),
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Documents' }],
      },
      props: true
    },
    {
      path: '/clearance-document/daa',
      name: 'daa',
      component: () => import('../views/clearance-document/DAA.vue'),
      beforeEnter: (to) => ('id' in to.query) || { name: 'issue-of-documents' },
      meta: {
          breadcrumb: [{ parent: 'Home', label: 'Documents' }],
      },
      props: true
    },
    {
      path: '/last-fiscal-notification',
      name: 'last-fiscal-notification',
      component: () => import('../views/fiscal-notification/FiscalNotificationV2.vue'),
      beforeEnter: (to) => ('idScheduledOperation' in to.query) || { name: '/' },
      props: true
    },
    {
      path: '/fixed-balance-split',
      name: 'fixed-balance-split',
      component: () => import('../views/operative-plan/FixedBalanceSplit.vue'),
      props: true
    },
    {
      path: '/fiscal-notification',
      name: 'fiscal-notification',
      component: () => import('../views/communication/FiscalNotification.vue'),
      props: true
    },
    {
      path: '/discharge-tracking-report',
      name: 'discharge-tracking-report',
      component: () => import('../views/golden-power/DischargeTrackingReport.vue'),
      props: true
    },
    {
      path: '/discharge-tracking-detail/:id',
      name: 'discharge-tracking-detail',
      component: () => import('../views/golden-power/DischargeTrackingDetail.vue'),
      props: true
    },
    {
      path: '/raw-material-check',
      name: 'raw-material-check',
      component: () => import('../views/golden-power/RawMaterialCheck.vue'),
      props: true
    },
    {
      path: '/planning/vessel-summary',
      name: 'planning-vessel-summary',
      component: () => import('../views/planning/VesselSummary.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Vessel Summary' }],
      }
    },
    {
      path: '/planning/vessel-deal-note',
      name: 'planning-deal-note',
      component: () => import('../views/planning/DealNote.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Deal Note' }],
      }
    },
    {
      path: '/weekly-settlement',
      name: 'weekly-settlement',
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Weekly Settlement' }],
      },
      component: () => import('../views/movement-instruction/WeeklySettlement.vue'),
      props: true
    },
    {
      path: '/planning/daily-profiles',
      name: 'planning-daily-profiles',
      component: () => import('../views/planning/DailyProfiles.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Daily Profiles' }],
      }
    },
    {
      path: '/planning/true-up-price-formula',
      name: 'price-formula',
      component: () => import('../views/planning/trueUp/PriceFormula.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Price Formula' }],
      }
    },
    {
      path: '/planning/true-up-settle',
      name: 'true-up-settle',
      component: () => import('../views/planning/trueUp/Settle.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Settle' }],
      }
    },
    {
      path: '/planning/true-up-provisional-invoice',
      name: 'provisional-invoice',
      component: () => import('../views/planning/trueUp/ProvisionalInvoice.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Provisional Invoice' }],
      }
    },
    {
      path: '/planning/true-up-density-estimation',
      name: 'density-estimation',
      component: () => import('../views/planning/trueUp/DensityEstimation.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Density Estimation' }],
      }
    },
    {
      path: '/planning/true-up-invoice-prices',
      name: 'invoice-prices',
      component: () => import('../views/planning/trueUp/InvoicePrices.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Invoice Prices' }],
      }
    },
    {
      path: '/planning/true-up-feedstocks-weighted-average',
      name: 'feedstocks-weighted-average',
      component: () => import('../views/planning/trueUp/FeedstocksWeightedAverage.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Feedstocks Weighted Average' }],
      }
    },
    {
      path: '/planning/true-up-priced-quantities-balance',
      name: 'priced-quantities-balance',
      component: () => import('../views/planning/trueUp/PricedQuantitiesBalance.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Priced Quantities Balance' }],
      }
    },
    {
      path: '/planning/true-up-final-invoice',
      name: 'final-invoice',
      component: () => import('../views/planning/trueUp/FinalInvoice.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Final Invoice' }],
      }
    },
    {
      path: '/planning/deal-note-price-window',
      name: 'planning-price-window',
      component: () => import('../views/planning/PriceWindow.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Price Window' }],
      }
    },
    {
      path: '/material-balance/periodic-movement-by-sea-report',
      name: 'periodic-movement-by-sea-report',
      component: () => import('../views/material-balance/PeriodicMovementBySeaReport.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Final Invoice' }],
      }
    },
    {
      path: '/vessel-nomination',
      name: 'vessel-nomination',
      component: () => import('../views/movement-instruction/VesselNomination.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Final Invoice' }],
      }
    },          
    {
      path: '/planning/book-out',
      name: 'book-out',
      component: () => import('../views/planning/BookOut.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Book Out' }],
      }
    },
    {
      path: '/planning/eudora-interface-density-estimation',
      name: 'density-estimation-eudora',
      component: () => import('../views/planning/eudoraInterface/DensityEstimation.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Density Estimation' }],
      }
    },
    {
      path: '/planning/eudora-interface-premium-discount-calculation-details',
      name: 'premium-discount-calculation-details',
      component: () => import('../views/planning/eudoraInterface/PremiumDiscountCalculationDetail.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Premium/Discount calulation details' }],
      }
    },
    {
      path: '/equipment-operation/denaturant-bulk-registry',
      name: 'denaturant-bulk-registry',
      component: () => import('../views/equipment-operation/DenaturantBulkRegistry.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'DenaturantBulkRegistry' }],
      }
    },
    {
      path: '/planning/true-up-stock-adjustment',
      name: 'stock-adjustment',
      component: () => import('../views/planning/StockAdjustment.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Stock Adjustment' }],
      }
    },        
    {
      path: '/tankManagement/tm-tank-volumetric-data',
      name: 'volumetric-data',
      component: () => import('../views/tank-management/TmTankVolumetricData.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Volumetric Data' }],
      }          
    },
    {
      path: '/excise-fiscal-register',
      name: 'excise-fiscal-register',
      component: () => import('../views/fiscal-notification/ExciseFiscalRegister.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: 'Excise Fiscal Register' }],
      }
    },
    {
      path: '/demurrage/calculator/:id',
      name: 'demurrage-calculator-detail',
      props: true,
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Demurrage Calculator' }],
      },
      component: () => import('../views/demurrage/DemurrageCalculator.vue'),
    },    
    {
      path: '/demurrage/calculator',
      name: 'demurrage-calculator',
      props: true,
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Demurrage Calculator' }],
      },
      component: () => import('../views/demurrage/DemurrageCalculator.vue'),
    },      
    {
      path: '/demurrage/register',
      name: 'demurrage-register',
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Demurrage Register' }],
      },
      component: () => import('../views/demurrage/DemurrageRegister.vue'),
      props: true
    },      
    {
      path: '/demurrage/statistics',
      name: 'demurrage-statistics',
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Demurrage Register' }],
      },
      component: () => import('../views/demurrage/DemurrageStatistics.vue'),
      props: true
    },
    {
      path: '/stock-management/discharge-drops-report',
      name: 'discharge-drops-report',
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Discharge Drops Report' }],
      },
      component: () => import('../views/stock-management/DischargeDropsReport.vue'),
      props: true
    },
    {
      path: '/versalis-product-movements',
      name: 'versalis-product-movements',
      component: () => import('@/views/versalis/ProductMovements.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: ' ' }],
      }
    },
    {
      path: '/versalis-raw-material-movements',
      name: 'versalis-raw-material-movements',
      component: () => import('@/views/versalis/RawMaterialMovements.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: ' ' }],
      }
    },
    {
      path: '/versalis-register',
      name: 'versalis-register',
      component: () => import('@/views/versalis/LoadingUnloadingRegister.vue'),
      props: true,
      meta: {
            breadcrumb: [{ parent: 'Home', label: ' ' }],
      }
    },
    {
      path: '/movement-instruction/site-contract',
      name: 'movement-instruction-site-contract',
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Site COntract' }],
      },
      component: () => import('../views/movement-instruction/MovementInstructionSiteContract.vue'),
      props: true
    },
    {
      path: '/planning/rolling-inventory',
      name: 'planning-rolling-inventory',
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Rolling Inventory Estimation' }],
      },
      component: () => import('../views/planning/RollingInventoryEstimation.vue'),
      props: true
    },
    {
      path: '/true-up/tolling-price',
      name: 'true-up-tolling-price',
      meta: {
        breadcrumb: [{ parent: 'Home', label: 'Tolling Price' }],
      },
      component: () => import('../views/planning/trueUp/TollingPrice.vue'),
      props: true
    }           
  ]
})

router.beforeEach((to, from, next) => {
  if(from && from.href){
    store.dispatch("security/addNavigationHistory", {
      title: store.state.security.navbarTitle ? store.state.security.navbarTitle : 'Home',
      href: from.href
    });
  }
  store.dispatch("security/removeNavigationHistory", to.href);


  if(to.name != "login" && to.name != "reset-password" && to.name != "input-for-reset-password" && to.name != "update-password" && !store.state.security.user){
    next("/login");
  }else if(to.name == "login" && store.state.security.user){
    next("/");
  }else if(to.name == "reset-password" && store.state.security.user){
    next("/");
  }else if(to.name == "input-for-reset-password" && store.state.security.user){
    next("/");
  }else if(to.name == "update-password" && store.state.security.user){
    next("/");
  }else{
    next();
  }
})

export default router
